import { Box, Icon, IconName } from '@usealloy/component-library';
import type { PropsWithChildren } from 'react';
import React, { useState } from 'react';

type Props = {
  header: React.ReactNode;
};

export const MatchDetailCard = ({ header, children, ...rest }: PropsWithChildren<Props>) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  return (
    <Box {...rest} style={{ display: 'block', padding: 0 }}>
      <Box
        onClick={() => setIsCollapsed(!isCollapsed)}
        style={{
          backgroundColor: 'var(--cl-gray-200)',
          borderRadius: 'var(--cl-radius-3)',
          height: 40,
          padding: '0 var(--cl-space-2)',
          cursor: 'pointer',
        }}
      >
        <Icon icon={isCollapsed ? IconName.CaretRight : IconName.CaretDown} size="large" />
        {header}
      </Box>
      <Box style={{ padding: 'var(--cl-space-2)' }} hidden={isCollapsed}>
        {children}
      </Box>
    </Box>
  );
};
